import React, { useEffect, useState } from 'react'
import Header from '../Header/Header'
import { useTranslation } from 'react-i18next';
import Sidebar from '../../pages/Sidebar'
import Cookies from "js-cookie";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { createUserAction, getUserDetailAction, updateUserAction } from '../../actions/userAction';
import { useDispatch, useSelector } from 'react-redux';
import './CreateUser.scss';
import PhoneInput from "react-phone-input-2";
import Validation from '../../constants/validation/Validation';
import { NotificationManager } from 'react-notifications';
import { HTTP_STATUS } from '../../constants/httpstatus/HttpsStatus';
import { hasAnyPermission } from '../../utils/permissionUtils';
import { PERMISSIONS } from '../../constants/permissions/Permissions';

const CreateUser = () => {

    const { i18n, t } = useTranslation();
    const language = Cookies.get("language");
    const countryCode = localStorage.getItem('countryPhoneCode')
    const countryDomain = localStorage.getItem('countryCode');
    const countryPhoneLength = localStorage.getItem('countryPhoneLength')
    const countryMinPhoneLength = localStorage.getItem('countryMinPhoneLength');
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const { userId } = useParams();
    const { roles } = location.state || {};
    const { users } = location.state || {};
    const isEditMode = !!userId;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        name: '',
        mobile_number: '',
        role_id: '',
        email: '',
    });

    const { userDetails, loading } = useSelector((state) => state.getUserDetailReducer);

    const validateAlphabets = (value) => {
        const regex = /^[\p{L}\s]*$/u;
        return regex.test(value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'name') {
            if (!validateAlphabets(value)) {
                return;
            }
        }

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const isFormValid = () => {
        return Object.values(formData).every(field =>
            field !== null && field !== undefined && String(field).trim() !== ''
        ) && formData.role_id !== '' && phoneNumber.length >= countryMinPhoneLength;
    };

    useEffect(() => {
        handleChangeLanguage(language);
    }, []);

    const handlePhoneNumberChange = (e) => {
        const phoneValue = e.target.value.replace(/\D/g, '');
        setPhoneNumber(phoneValue);
        setFormData({
            ...formData,
            mobile_number: phoneValue
        });
    };

    const handleChangeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    const handleSubmit = async () => {
        if (!isFormValid() || isLoading) return;
        setIsLoading(true);

        const payload = {
            ...formData,
            role_id: parseInt(formData.role_id, 10),
        };

        let response;
        if (isEditMode) {
            response = await dispatch(updateUserAction(userId, payload));
        } else {
            response = await dispatch(createUserAction(payload));
        }

        const { status, message } = response;

        if (status === HTTP_STATUS.CREATED || status === HTTP_STATUS.SUCCESS) {
            NotificationManager.success(message);
            navigate('/roles_and_permission', { state: { activeComponent: 'userManagement' } });
        } else {
            NotificationManager.error(message || t('common.somethingWentWrong'));
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (isEditMode) {
            dispatch(getUserDetailAction(userId));
        }
    }, [dispatch, isEditMode, userId]);

    useEffect(() => {
        if (isEditMode && userDetails) {
            setFormData({
                name: userDetails.name || '',
                mobile_number: userDetails.mobile_number || '',
                role_id: userDetails.role_id || '',
                email: userDetails.email || '',
            });
            setPhoneNumber(userDetails.mobile_number || '');
        }
    }, [isEditMode, userDetails]);

    return (
        <div className='create-user-container'>
            <div className='user-container-section'>
                <div className='create-user'>
                    <div className="header-navigation">
                        <p className="create-user-text">TVS &gt; {t('RolesAndPermission.rolesAndPermission')}</p>
                    </div>
                    <div className='create-user-main'>
                        <h3>
                            {isEditMode ? t('userManagement.editUser') : t('userManagement.createUser')}
                        </h3>
                        <div className='create-user-form'>
                            <form className='user-form'>
                                <div className='form-section'>
                                    <div className='form-input'>
                                        <label className='user-iput-label required'>{t('common.nameLabel')}</label>
                                        <input
                                            className='user-input'
                                            type='text'
                                            name='name'
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            placeholder={t('common.namePlaceholder')}
                                        />
                                    </div>
                                    <div className='form-input'>
                                        <label className='user-iput-label required'>{t('addpartner.phoneNumberLabel')}</label>
                                        <div className="phone_input">
                                            <PhoneInput
                                                country={countryDomain}
                                                value={countryCode}
                                                disableDropdown={true}
                                                inputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                            <span className="phone_bar">|</span>
                                            <input
                                                className="number_inp"
                                                maxLength={countryPhoneLength}
                                                type="text"
                                                name='mobile_number'
                                                value={phoneNumber}
                                                onKeyPress={(e) => Validation.numberinputValidator(e)}
                                                onChange={handlePhoneNumberChange}
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-section'>
                                    <div className='form-input'>
                                        <label className='user-iput-label required'>{t('common.emailIdLabel')}</label>
                                        <input
                                            className='user-input'
                                            type='email'
                                            name='email'
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder={t('common.emailPlaceholder')}
                                            readOnly={isEditMode}
                                        />
                                    </div>
                                    <div className='form-input'>
                                        <label className='user-iput-label required'>{t('RolesAndPermission.role')}</label>
                                        <select
                                            className='user-input'
                                            name='role_id'
                                            value={formData.role_id}
                                            onChange={handleInputChange}
                                        >
                                            <option value="" disabled>{t('userManagement.selectRole')}</option>
                                            {roles && roles.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.role}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </form>
                            <div className='cancel-submit-btn'>
                                <button className='cancel-btn' onClick={() => navigate('/roles_and_permission', { state: { activeComponent: 'userManagement' } })}>{t('common.cancel')}</button>
                                {hasAnyPermission([PERMISSIONS.CAN_ONBOARD_ADMIN_USER, PERMISSIONS.CAN_UPDATE_ADMIN_USER]) && (
                                    <button
                                        className='submit-btn'
                                        disabled={!isFormValid() || isLoading}
                                        onClick={handleSubmit}
                                    >
                                        {isLoading ? <span className="loader-btn"></span> : (isEditMode ? t('common.update') : t('common.submit'))}
                                    </button>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser